import { Drawer, Overlay } from '@mantine/core';

export const OverlayTheme = Overlay.extend({
	styles: (_theme, _props, _ctx) => ({
		root: {
			backgroundColor: 'var(--apple-material-under-window-bg-color)',
			backdropFilter: 'var(--apple-material-under-window-bd-filter)',
		},
	}),
});

export const DrawerOverlayTheme = Drawer.extend({
	styles: () => ({
		overlay: {
			backgroundColor: 'var(--apple-color-under-drawer-bg-color)',
			backdropFilter: 'unset',
		},
	}),
});
